import React from 'react';
export function FooterSection() {
  return <footer className="bg-navy text-cream py-12 border-t border-white/10" data-id="element-45">
      <div className="container mx-auto px-4 text-center" data-id="element-46">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-47">
          <img src="https://cdn.magicpatterns.com/uploads/sLH5EnP1vGCj8ixaNNFVz5/Logo_Tu_Aura_Ok_Ok.png" alt="Logo" className="w-16 h-16 object-contain" data-id="element-48" />
          <span className="font-heading font-bold text-xl tracking-wide" data-id="element-49">
            Tu Aura Simple
          </span>
        </div>
        <p className="text-gray-400 text-sm" data-id="element-50">
          © {new Date().getFullYear()} Tu Aura Simple. Todos los derechos
          reservados.
        </p>
        <div className="mt-4 flex justify-center gap-6 text-xs text-gray-500" data-id="element-51">
          <a href="#" className="hover:text-white transition-colors" data-id="element-52">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-53">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}